import React from "react";

import { EuiCallOut } from "@equipmentshare/ds2";

import { Time } from "~/Time";

type DriverTimezoneBannerProps = {
  readonly driverTimezone: Time.Zone;
};

export const DriverTimezoneBanner = ({
  driverTimezone
}: DriverTimezoneBannerProps) => {
  return (
    <EuiCallOut
      iconType="iInCircle"
      size="s"
      title={<TitleComponent driverTimezone={driverTimezone} />}
    ></EuiCallOut>
  );
};

const TitleComponent = ({ driverTimezone }: DriverTimezoneBannerProps) => {
  return (
    <span data-testid="driver-timezone-info-banner">
      {"All revisions will be made in the driver’s time zone: "}
      <strong>{driverTimezone.zone.replace("_", " ")}</strong>
    </span>
  );
};
